import { render, staticRenderFns } from "./promotion-analysis-detail.vue?vue&type=template&id=68f69f0e&scoped=true&"
import script from "./promotion-analysis-detail.vue?vue&type=script&lang=js&"
export * from "./promotion-analysis-detail.vue?vue&type=script&lang=js&"
import style0 from "./promotion-analysis-detail.vue?vue&type=style&index=0&id=68f69f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f69f0e",
  null
  
)

export default component.exports